const firebaseConfig = {
  apiKey: "AIzaSyD4JPjzLDFDL0SwEq2B50HWB7xtrSQ60U4",
  authDomain: "creative-agency-96502.firebaseapp.com",
  databaseURL: "https://creative-agency-96502.firebaseio.com",
  projectId: "creative-agency-96502",
  storageBucket: "creative-agency-96502.appspot.com",
  messagingSenderId: "512128284456",
  appId: "1:512128284456:web:5b6cf01e04a9181ece021d"
};

export default firebaseConfig;